import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api"; 

// Get all events
export const getAllEvents = async () => {
  try {
    const res = await axios.get(`${API_URL}/events`);
     console.log("Fetched events:", res.data); 
    return res.data;
  } catch (err) {
    console.error("Error fetching events:", err);
    throw err;
  }
};

// Purchase ticket (provisional payment)
export const purchaseTicket = async (token, event_id, ticket_id, quantity, amount) => {
  try {
    const payment_id = `PH_${Date.now()}`;

    const res = await axios.post(
      `${API_URL}/events/purchase`,
      { event_id, ticket_id, quantity, amount, payment_id },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return { ...res.data, payment_id };
  } catch (err) {
    throw err;
  }
};

export const getEventRequestStatus = async () => {
  try {
    const token = localStorage.getItem("jwt_token");

    const res = await fetch(`${API_URL}/event-request/status`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await res.json(); 
  } catch (err) {
    console.error("Error fetching event request status:", err);
    return null;
  }
};

export const createEventRequest = async () => {
  try {
    const token = localStorage.getItem("jwt_token");

    const res = await fetch(`${API_URL}/event-request`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return await res.json();
  } catch (err) {
    console.error("Error creating event request:", err);
    return null;
  }
};

export const createEvent = async (formData) => {
  try {
    const token = localStorage.getItem("jwt_token"); 
    const response = await axios.post(`${API_URL}/events`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Error creating event:", err);
    throw err.response?.data || { message: "Error creating event" };
  }
};
export const deleteEvent = (eventId) => {
  const token = localStorage.getItem("jwt_token"); 

  if (!token) throw new Error("User not logged in");

  return axios.delete(`${API_URL}/events/${eventId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateEvent = async (id, formData) => {
  const token = localStorage.getItem("jwt_token");
  if (!token) throw new Error("User not logged in");

  const res = await axios.put(`${API_URL}/events/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

export const getEventById = async (id) => {
  const token = localStorage.getItem("jwt_token"); // or "token" if you stored it like that
  if (!token) throw new Error("User not logged in");

  const res = await axios.get(`${API_URL}/events/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const getAgentStatus = async () => {
  try {
    const token = localStorage.getItem("jwt_token");

    const response = await axios.get(
      `${API_URL}/agents/status`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // response.data = { status: number | null }
    return response.data.status;
  } catch (error) {
    console.error("Error fetching agent status:", error);
    return null;
  }
};

// Start Koko Event Payment
export const startKokoEventPayment = async (bookingPayload) => {
  try {
    const res = await axios.post(`${API_URL}/events/koko/start`, bookingPayload, {
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    });
    return res.data;
  } catch (err) {
    console.error("Error starting KOKO event payment:", err);
    throw err.response?.data || err;
  }
};

